import React, { useCallback, useState } from 'react'
import { Collapse, makeStyles, ButtonBase, styled } from '@material-ui/core'
import { ExpandMoreRounded } from '@material-ui/icons'
import { gray, purple } from '../../../../../utils/colors'
import { FONT_WEIGHTS } from '../../../../../utils'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'column', marginTop: '0.7rem' },
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: `1px solid ${gray[500]}`,
		height: '2rem',
		marginBottom: '0.875rem'
	},
	title: {
		fontFamily: 'Nunito',
		fontWeight: FONT_WEIGHTS.SemiBold,
		color: gray[900],
		fontSize: '0.875rem'
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '.75rem'
	},
	shiftButton: {
		border: `1px solid ${gray[500]}`,
		borderRadius: '0.3125rem',
		width: '22%',
		color: gray[900],
		padding: '0.4rem 0',
		fontFamily: 'Nunito',
		fontWeight: FONT_WEIGHTS.SemiBold,
		fontSize: '0.875rem'
	},
	shiftButtonSelected: {
		borderColor: purple[700],
		backgroundColor: purple[100],
		color: purple[700]
	}
}))

const ExpandMore = styled((props) => {
	const { expand, ...other } = props
	return (
		<ButtonBase {...other} disableRipple>
			<ExpandMoreRounded fontSize="small" style={{ color: gray[600] }} />
		</ButtonBase>
	)
})(({ theme, expand }) => ({
	transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
	marginLeft: 'auto',
	transition: theme.transitions.create('transform', {
		duration: theme.transitions.duration.shortest
	})
}))

const ShiftSelection = ({ title = '', shifts = [], onShiftSelected, currentSelection }) => {
	const classes = useStyles()
	const [collapse, setCollapse] = useState(false)
	const handleCollapse = useCallback(() => {
		setCollapse((prev) => !prev)
	}, [setCollapse])
	const handleOnShiftSelected = useCallback(
		(time) => {
			if (onShiftSelected) {
				onShiftSelected(time)
			}
		},
		[onShiftSelected]
	)
	return (
		<div className={classes.root}>
			<div className={classes.header}>
				<div className={classes.title}>{title}</div>
				<ExpandMore expand={!collapse} onClick={handleCollapse} />
			</div>

			<Collapse in={!collapse} timeout="auto">
				<div className={classes.buttonContainer}>
					{shifts.length === 0 ? <div>No shifts available</div> : null}
					{shifts.map((time) => (
						<ButtonBase
							className={`${classes.shiftButton} ${
								currentSelection === time ? classes.shiftButtonSelected : ''
							}`}
							disabled={currentSelection === time}
							onClick={() => handleOnShiftSelected(time)}>
							{time}
						</ButtonBase>
					))}
				</div>
			</Collapse>
		</div>
	)
}

export default ShiftSelection
